let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iYSPi")).then(() => parcelRequire('10xW0'));